export default {
    namespaced: true,
    state: {
        selected: {}
    },
    getters: {
        selected: (state) => (type) => {
            return state.selected[type];
        },
        findSource: (state) => (sourceId) => {
            let sources = state.selected['sources'];
            for(let index in sources) {
                if(sources.hasOwnProperty(index)) {
                    if(sources[index].value === sourceId) {
                        return sources[index];
                    }
                }
            }
            return null;
        },
        findType: (state) => (typeId) => {
            let types = state.selected['types'];
            for(let index in types) {
                if(types.hasOwnProperty(index)) {
                    if(types[index].value === typeId) {
                        return types[index];
                    }
                }
            }
            return null;
        }
    },
    actions: {
    },
    mutations: {
        selected (state, elm) {
            state.selected[elm.type] = elm.results;
        }
    }
}